const dropDown = document.querySelectorAll('.dropdown');

const dropDownAction = (drop) => {
   
    const opsBox = drop.querySelector('.dropdown-menu');
    const select = drop.querySelector('.styledSelect');
    const options = opsBox.querySelectorAll('li');

    options.forEach((option) => {
        option.addEventListener('click', (e) => {
            select.innerText = e.target.innerText;
        });
    });
};

dropDown.forEach((drop) => {
    drop.addEventListener('click', () => {dropDownAction(drop)});
});

const listEstate = document.querySelectorAll(".dwn");
const show = document.querySelector('.results-rs');
const subBtn = document.querySelector('#form-btn-rs');
const showEstate = document.querySelector('#allEstates');

function selectEstate() {
    const land = document.querySelector('#land').innerText;
    const kind = document.querySelector('#kind').innerText;

    let landCheck = '';
    let kindCheck = ''; 
    
    if(!(land == 'Wybierz województwo' ) && !(land == 'Wszystkie')) {
        landCheck = land;
    } 
    
    if(!(kind == 'Rodzaj nieruchomości') && !(kind == 'Wszystkie')) {
        kindCheck = kind;
    } 
    let elements = [...listEstate];
    
    elements = elements.filter(item => {
        return item.dataset.land.includes(landCheck)
    });
    elements = elements.filter(item => {
        return item.dataset.kind.includes(kindCheck)
    });
    showEstate.textContent = "";
    elements.length ? elements.forEach(item => showEstate.appendChild(item)) : showEstate.innerHTML = "<p class='p2a text-center'>Brak wyników dla żądanych kryteriów</p>";
}
if (subBtn !== undefined && subBtn !== null) {
subBtn.addEventListener('click', () => {
    selectEstate();

});
}